module.exports = __webpack_public_path__ + "img/LK.2a0a03d7.svg";